import React, { useState, useEffect, useCallback, useRef } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    width: 438,
    height: 'auto',
    '& img': {
      width: '100%'
    }
  }
}));

interface Props {
  aspect: number;
  cropedImageBlob: Blob;
  setCropedImageBlob: (data: Blob) => void;
  src: string;
  onSubmit: (files: any) => void;
}

const ImageCropPresenter = (props: Props) => {
  const classes = useStyles();
  const imgRef = useRef(null);
  const [completedCrop, setCompletedCrop]: any = useState(null);
  const [crop, setCrop] = useState<ReactCrop.Crop>({
    unit: 'px',
    width: 300,
    aspect: props.aspect
  });

  useEffect(() => {
    const image: any = imgRef.current;
    if (!completedCrop || !imgRef.current) {
      return;
    }

    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = Math.ceil(completedCrop.width * scaleX);
    canvas.height = Math.ceil(completedCrop.height * scaleY);
    const ctx: CanvasRenderingContext2D = canvas.getContext('2d')!;
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY
    );

    ctx.imageSmoothingQuality = 'high';

    canvas.toBlob((blob) => {
      if (blob) {
        props.setCropedImageBlob(blob);
      }
    });
    // eslint-disable-next-line
  }, [completedCrop]);

  const onCropComplete = (crop: ReactCrop.Crop) => {
    setCompletedCrop(crop);
  };

  const onCropChange = (crop: ReactCrop.Crop) => {
    setCrop(crop);
  };

  const onImageLoaded = useCallback((img) => {
    imgRef.current = img;
  }, []);

  return (
    <ReactCrop
      className={classes.root}
      src={props.src}
      crop={crop}
      onImageLoaded={onImageLoaded}
      onComplete={onCropComplete}
      onChange={onCropChange}
      crossorigin="anonymous"
    />
  );
};

export default ImageCropPresenter;
